import { useTranslation } from "react-i18next";
import { Field } from "../../../../components/shared/Form";
import SwitchNumberInput from "../components/SwitchNumberInput";

const types: string[] = [
    "shift",
    "edit-shift",
    "edit-timesheet",
    "absence",
];

function Expiration() {
    const { t } = useTranslation();
    return (
        <div className="tw-p-5 tw-flex tw-flex-col tw-gap-1">
            {types.map((type) => (
                <Field
                    className="tw-mb-3"
                    name={`expiration.${type}`}
                    shouldUnregister={false}
                    key={type}
                >
                    <SwitchNumberInput label={t(type)} unit="days" />
                </Field>
            ))}
        </div>
    );
}

export default Expiration;
